export default __webpack_public_path__ + "static/media/advantage-3.bcffb721.png";